import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import {
  buildThemeHref,
  DISCOVERY_THEME_ORDER,
  getDiscoveryTheme,
  readDiscoveryTheme,
} from '../../lib/discoveryThemes';

export const ThemeSwitch = ({ pathname, className = '', overrides = {} }) => {
  const location = useLocation();
  const activeTheme = readDiscoveryTheme(location.search);
  const targetPath = pathname || location.pathname;

  return (
    <div className={`atlas-theme-switch ${className}`.trim()} role="tablist" aria-label="Discovery themes">
      {DISCOVERY_THEME_ORDER.map((themeKey) => {
        const theme = getDiscoveryTheme(themeKey);
        const href = buildThemeHref(targetPath, location.search, themeKey, overrides);

        return (
          <Link
            key={themeKey}
            role="tab"
            aria-selected={activeTheme === themeKey}
            className={`atlas-theme-pill ${activeTheme === themeKey ? 'is-active' : ''}`}
            to={href}
          >
            {theme.label}
          </Link>
        );
      })}
    </div>
  );
};
